var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm__slug"},[_c('div',{staticClass:"hm__slug-pic",attrs:{"aria-hidden":"true"}},[_vm._t("img")],2),_c('div',{staticClass:"hm__slug-title"},[_vm._t("title")],2),_c('p',{staticClass:"hm__slug-text"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }